import { useState, useEffect } from 'react';
import { axiosInstance } from '../App';

// Senarai kelas lalai (fallback jika API gagal)
export const DEFAULT_CLASSES = [
  "Baby Care (2-12 months)",
  "Toddler Playgroup I (1-2 years old)",
  "Toddler Playgroup II (2-3 years old)",
  "Nursery Exploration (3-4 years old)",
  "Pre-school (Kindergarten 4-6 years old)",
];

// Cache global supaya semua komponen kongsi satu fetch
let cachedClasses = null;
let fetchPromise = null;

const fetchClasses = async () => {
  if (fetchPromise) return fetchPromise;
  fetchPromise = axiosInstance
    .get('/classes')
    .then((res) => {
      cachedClasses = res.data?.classes?.length ? res.data.classes : DEFAULT_CLASSES;
      return cachedClasses;
    })
    .catch(() => {
      cachedClasses = DEFAULT_CLASSES;
      return cachedClasses;
    })
    .finally(() => {
      fetchPromise = null;
    });
  return fetchPromise;
};

export const invalidateClassesCache = () => {
  cachedClasses = null;
};

// Hook untuk dapatkan senarai kelas dinamik dari DB
export const useClasses = () => {
  const [classes, setClasses] = useState(cachedClasses || DEFAULT_CLASSES);
  const [loading, setLoading] = useState(cachedClasses === null);

  useEffect(() => {
    let mounted = true;
    if (cachedClasses === null) {
      fetchClasses().then((list) => {
        if (mounted) {
          setClasses(list);
          setLoading(false);
        }
      });
    } else {
      setClasses(cachedClasses);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, []);

  return { classes, loading };
};

export default useClasses;
